import { ToggleGroupItem, ToggleGroupItemProps } from "./ToggleGroupItem";
import { ToggleGroupRoot, ToggleGroupRootProps } from "./ToggleGroupRoot";

export declare namespace ToggleGroupProps {
  export type Item = ToggleGroupItemProps;
  export type Root = ToggleGroupRootProps;
}

export const ToggleGroup = {
  Item: ToggleGroupItem,
  Root: ToggleGroupRoot,
};
